import React from 'react';
import PropTypes from 'prop-types';

const CharterRateColumn = ({ title, lowRate, highRate, isAllYear = false }) => {
  const values = [lowRate, highRate].filter(Boolean);
  if (!values.length) return null;

  const valuesTheSame = new Set(values).size === 1;
  const showLowSeasonLabel = !isAllYear; // if it's all year, we don't need to show the low season label because there is only one column
  // if the values are the same, we can just show 'All Season' instead of 'Low season' if it's not all year to keep the same spacing
  const lowSeasonLabel = !valuesTheSame ? 'Low season' : 'All Season';

  return (
    <div className="charter-rate-summary--column">
      {title && <h4>{title}</h4>}
      {showLowSeasonLabel && <p>{lowSeasonLabel}</p>}
      <div className="charter-rate-summary--rate-large">{lowRate || highRate}</div>
      {title && <span>Per week</span>}
      {!valuesTheSame && (
        <p>
          High Season <br />
          {highRate} p/w
        </p>
      )}
    </div>
  );
};

CharterRateColumn.propTypes = {
  title: PropTypes.string.isRequired,
  lowRate: PropTypes.string.isRequired,
  highRate: PropTypes.string.isRequired,
  isAllYear: PropTypes.bool
};

CharterRateColumn.defaultProps = {
  isAllYear: false
};

export default CharterRateColumn;
